import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-19d0f174"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "fase-wrapper" };
const _hoisted_2 = { class: "phase-header" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "phase-header-left" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "phase-badge" }, "Fase 4"),
    /*#__PURE__*/ _createElementVNode("div", null, [
        /*#__PURE__*/ _createElementVNode("h2", { class: "phase-title" }, "Transferencia Permanente al Inventario"),
        /*#__PURE__*/ _createElementVNode("p", { class: "phase-desc" }, "Aprobación definitiva. Inyecta el lote al inventario e impacta la disponibilidad.")
    ])
], -1 /* HOISTED */));
const _hoisted_4 = {
    key: 0,
    class: "phase-actions"
};
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-arrow-left" }, null, -1 /* HOISTED */));
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-bolt" }, null, -1 /* HOISTED */));
const _hoisted_7 = { key: 0 };
const _hoisted_8 = { class: "panel-section" };
const _hoisted_9 = { class: "section-icon-title" };
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "section-icon blue" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-database" })
], -1 /* HOISTED */));
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", { class: "section-title" }, "Lotes Listos Para Transferencia", -1 /* HOISTED */));
const _hoisted_12 = {
    key: 0,
    class: "count-badge"
};
const _hoisted_13 = {
    key: 0,
    class: "empty-state"
};
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-empty-file" }, null, -1 /* HOISTED */));
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "No hay lotes cerrados pendientes de transferencia.", -1 /* HOISTED */));
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("small", null, "Finalice la Auditoría Administrativa (Fase 3) para que aparezcan aquí.", -1 /* HOISTED */));
const _hoisted_17 = [
    _hoisted_14,
    _hoisted_15,
    _hoisted_16
];
const _hoisted_18 = {
    key: 1,
    class: "table-scroll"
};
const _hoisted_19 = { class: "data-table" };
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", null, "Nro. Factura"),
        /*#__PURE__*/ _createElementVNode("th", null, "Proveedor"),
        /*#__PURE__*/ _createElementVNode("th", null, "Fecha Doc."),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-end" }, "Total Facturado"),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-center" }, "Estado"),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-end" }, "Acción")
    ])
], -1 /* HOISTED */));
const _hoisted_21 = { class: "code-badge primary" };
const _hoisted_22 = { class: "font-medium" };
const _hoisted_23 = { class: "text-muted" };
const _hoisted_24 = { class: "text-end font-bold text-success" };
const _hoisted_25 = { class: "text-center" };
const _hoisted_26 = { class: "status-badge success" };
const _hoisted_27 = { class: "text-end" };
const _hoisted_28 = ["onClick"];
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-bolt" }, null, -1 /* HOISTED */));
const _hoisted_30 = { key: 1 };
const _hoisted_31 = { class: "confirm-banner" };
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "banner-icon-wrap" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-shield" })
], -1 /* HOISTED */));
const _hoisted_33 = { class: "banner-content" };
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", null, "Confirmación de Transferencia Permanente", -1 /* HOISTED */));
const _hoisted_35 = { class: "banner-cta" };
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-arrow-left" }, null, -1 /* HOISTED */));
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-checkmark-circle" }, null, -1 /* HOISTED */));
const _hoisted_38 = { class: "panel-section" };
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "section-icon-title mb-3" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "section-icon teal" }, [
        /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-package" })
    ]),
    /*#__PURE__*/ _createElementVNode("h3", { class: "section-title" }, "Detalle del Lote — Solo Lectura")
], -1 /* HOISTED */));
const _hoisted_40 = { class: "table-scroll" };
const _hoisted_41 = { class: "data-table" };
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", null, "Facturación Física (Digitada)"),
        /*#__PURE__*/ _createElementVNode("th", null, "Repuesto / SKU Surtimotos Vinculado"),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-center" }, "Cant. Ingresa"),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-end" }, "Costo Real"),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-center" }, "Etiquetas a Imprimir"),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-center" }, "Vista Previa")
    ])
], -1 /* HOISTED */));
const _hoisted_43 = { class: "font-bold d-block text-slate-800" };
const _hoisted_44 = { class: "code-badge mt-1" };
const _hoisted_45 = { class: "font-medium d-block" };
const _hoisted_46 = { class: "text-muted mono-code" };
const _hoisted_47 = { class: "text-center" };
const _hoisted_48 = { class: "qty-badge" };
const _hoisted_49 = { class: "text-end font-medium" };
const _hoisted_50 = { class: "text-center" };
const _hoisted_51 = ["onUpdate:modelValue"];
const _hoisted_52 = { class: "text-center" };
const _hoisted_53 = ["onClick"];
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-eye" }, null, -1 /* HOISTED */));
const _hoisted_55 = [
    _hoisted_54
];
const _hoisted_56 = { class: "transfer-footer" };
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "destination-pill" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-delivery" }),
    /*#__PURE__*/ _createTextVNode(" Destino: "),
    /*#__PURE__*/ _createElementVNode("strong", null, "Almacén CEDI (Centro de Distribución)")
], -1 /* HOISTED */));
const _hoisted_58 = { class: "footer-actions" };
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-tag" }, null, -1 /* HOISTED */));
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-printer" }, null, -1 /* HOISTED */));
import { ref, computed, onMounted } from 'vue';
import { ComprasService } from '../../../services/ComprasService';
import Swal from 'sweetalert2';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Fase4Transferencia',
    setup(__props) {
        const ingresosTotalizados = ref([]);
        const selectedIngreso = ref(null);
        const totalEtiquetas = computed(() => {
            if (!selectedIngreso.value)
                return 0;
            return selectedIngreso.value.detalles.reduce((acc, curr) => acc + (curr.cantidadEtiquetas || 0), 0);
        });
        onMounted(() => { loadIngresos(); });
        const loadIngresos = async () => {
            try {
                const res = await ComprasService.getIngresos();
                ingresosTotalizados.value = (res || []).filter((i) => i.estadoCompraId === 3);
            }
            catch (error) {
                console.error(error);
            }
        };
        const seleccionarParaTransferencia = async (ingreso) => {
            try {
                const full = await ComprasService.getIngresoById(ingreso.ingresoCompraId);
                full.detalles = (full.detalles || []).map((d) => ({
                    ...d,
                    nombreProductoProveedor: d.nombreProductoProveedor || d.NombreProductoProveedor || '',
                    referenciaProductoProveedor: d.referenciaProductoProveedor || d.ReferenciaProductoProveedor || '',
                    cantidadEtiquetas: d.cantidad
                }));
                selectedIngreso.value = full;
            }
            catch (error) {
                Swal.fire({ icon: 'error', text: 'Error al cargar desglose' });
            }
        };
        const verEtiqueta = (det) => {
            Swal.fire({
                title: 'Vista Previa de Etiqueta',
                html: `
      <div style="border: 2px solid #000; padding: 12px; width: 260px; margin: 0 auto; background: #fff; border-radius: 8px;">
        <div style="font-weight: 800; border-bottom: 1px solid #000; margin-bottom: 8px; font-size: 14px; color: #1e293b;">SURTIMOTOS</div>
        <div style="font-size: 13px; margin-bottom: 4px; color: #374151;">${det.nombreRepuesto}</div>
        <div style="font-weight: 800; font-size: 18px; font-family: monospace; color: #0f172a;">${det.referencia || 'SIN-REF'}</div>
        <div style="margin-top: 8px;">
          <img src="https://barcodeapi.org/api/128/${det.referencia || '12345678'}" style="width: 100%; height: 50px;" />
        </div>
      </div>`,
                showConfirmButton: true
            });
        };
        const imprimirEtiquetas = (total) => {
            const count = total ? totalEtiquetas.value : selectedIngreso.value.detalles.filter((d) => d.cantidadEtiquetas > 0).reduce((acc, curr) => acc + curr.cantidadEtiquetas, 0);
            Swal.fire({ icon: 'info', title: 'Enviando a impresora...', text: `Se generarán ${count} etiquetas.`, timer: 3000, showConfirmButton: false });
        };
        const ejecutarTransferencia = async () => {
            try {
                const res = await ComprasService.transferir(selectedIngreso.value.ingresoCompraId, 1); // 1 = Almacen Principal
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'success',
                    title: '¡Transferencia Exitosa!',
                    text: res.message || 'Stock inyectado al Almacén CEDI y costos actualizados.',
                    timer: 4500,
                    showConfirmButton: false,
                    timerProgressBar: true
                });
                ingresosTotalizados.value = ingresosTotalizados.value.filter(i => i.ingresoCompraId !== selectedIngreso.value.ingresoCompraId);
                selectedIngreso.value = null;
                loadIngresos();
            }
            catch (error) {
                Swal.fire({ icon: 'error', title: 'Error', text: error.message || "Error al procesar transferencia" });
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createCommentVNode(" ── Phase Header ── "),
                _createElementVNode("div", _hoisted_2, [
                    _hoisted_3,
                    (selectedIngreso.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createElementVNode("button", {
                                class: "btn-outline-action",
                                onClick: _cache[0] || (_cache[0] = ($event) => (selectedIngreso.value = null))
                            }, [
                                _hoisted_5,
                                _createTextVNode(" Ver otros ")
                            ]),
                            _createElementVNode("button", {
                                class: "btn-primary-action",
                                onClick: ejecutarTransferencia
                            }, [
                                _hoisted_6,
                                _createTextVNode(" Transferir a Inventario ")
                            ])
                        ]))
                        : _createCommentVNode("v-if", true)
                ]),
                _createCommentVNode(" ── Selección de Ingreso Totalizado ── "),
                (!selectedIngreso.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                                _hoisted_10,
                                _hoisted_11,
                                (ingresosTotalizados.value.length > 0)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(ingresosTotalizados.value.length), 1 /* TEXT */))
                                    : _createCommentVNode("v-if", true)
                            ]),
                            (ingresosTotalizados.value.length === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_17))
                                : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                    _createElementVNode("table", _hoisted_19, [
                                        _hoisted_20,
                                        _createElementVNode("tbody", null, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ingresosTotalizados.value, (ing) => {
                                                return (_openBlock(), _createElementBlock("tr", {
                                                    key: ing.ingresoCompraId
                                                }, [
                                                    _createElementVNode("td", null, [
                                                        _createElementVNode("span", _hoisted_21, _toDisplayString(ing.numeroDocumento), 1 /* TEXT */)
                                                    ]),
                                                    _createElementVNode("td", _hoisted_22, _toDisplayString(ing.nombreProveedor), 1 /* TEXT */),
                                                    _createElementVNode("td", _hoisted_23, _toDisplayString(new Date(ing.fechaFacturacion).toLocaleDateString('es-VE', { day: '2-digit', month: 'short', year: 'numeric' })), 1 /* TEXT */),
                                                    _createElementVNode("td", _hoisted_24, "$" + _toDisplayString((ing.totalDocumento || 0).toFixed(2)), 1 /* TEXT */),
                                                    _createElementVNode("td", _hoisted_25, [
                                                        _createElementVNode("span", _hoisted_26, _toDisplayString(ing.nombreEstado), 1 /* TEXT */)
                                                    ]),
                                                    _createElementVNode("td", _hoisted_27, [
                                                        _createElementVNode("button", {
                                                            class: "btn-action-sm primary",
                                                            onClick: ($event) => (seleccionarParaTransferencia(ing))
                                                        }, [
                                                            _hoisted_29,
                                                            _createTextVNode(" Transferir ")
                                                        ], 8 /* PROPS */, _hoisted_28)
                                                    ])
                                                ]));
                                            }), 128 /* KEYED_FRAGMENT */))
                                        ])
                                    ])
                                ]))
                        ])
                    ]))
                    : _createCommentVNode("v-if", true),
                _createCommentVNode(" ── Pantalla de Transferencia Final ── "),
                (selectedIngreso.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        _createCommentVNode(" Confirmación Banner "),
                        _createElementVNode("div", _hoisted_31, [
                            _hoisted_32,
                            _createElementVNode("div", _hoisted_33, [
                                _hoisted_34,
                                _createElementVNode("p", null, [
                                    _createTextVNode("Lote Documento "),
                                    _createElementVNode("strong", null, _toDisplayString(selectedIngreso.value.numeroDocumento), 1 /* TEXT */),
                                    _createTextVNode(" · "),
                                    _createElementVNode("strong", null, _toDisplayString(selectedIngreso.value.nombreProveedor), 1 /* TEXT */)
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_35, [
                                _createElementVNode("button", {
                                    class: "btn-outline-action",
                                    onClick: _cache[1] || (_cache[1] = ($event) => (selectedIngreso.value = null))
                                }, [
                                    _hoisted_36,
                                    _createTextVNode(" Ver otros ")
                                ]),
                                _createElementVNode("button", {
                                    class: "btn-primary-action",
                                    onClick: ejecutarTransferencia
                                }, [
                                    _hoisted_37,
                                    _createTextVNode(" Transferir a Inventario ")
                                ])
                            ])
                        ]),
                        _createCommentVNode(" Listado de Detalles "),
                        _createElementVNode("div", _hoisted_38, [
                            _hoisted_39,
                            _createElementVNode("div", _hoisted_40, [
                                _createElementVNode("table", _hoisted_41, [
                                    _hoisted_42,
                                    _createElementVNode("tbody", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedIngreso.value.detalles, (det, idx) => {
                                            return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                                                _createElementVNode("td", null, [
                                                    _createElementVNode("span", _hoisted_43, _toDisplayString(det.nombreProductoProveedor || 'N/A'), 1 /* TEXT */),
                                                    _createElementVNode("span", _hoisted_44, _toDisplayString(det.referenciaProductoProveedor || 'N/A'), 1 /* TEXT */)
                                                ]),
                                                _createElementVNode("td", null, [
                                                    _createElementVNode("span", _hoisted_45, _toDisplayString(det.nombreRepuesto || '- Sin Vincular -'), 1 /* TEXT */),
                                                    _createElementVNode("code", _hoisted_46, _toDisplayString(det.codigoRepuesto || 'REF-N/A'), 1 /* TEXT */)
                                                ]),
                                                _createElementVNode("td", _hoisted_47, [
                                                    _createElementVNode("span", _hoisted_48, "+" + _toDisplayString(det.cantidad), 1 /* TEXT */)
                                                ]),
                                                _createElementVNode("td", _hoisted_49, "$" + _toDisplayString(det.precioBaseFactura.toFixed(2)), 1 /* TEXT */),
                                                _createElementVNode("td", _hoisted_50, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "number",
                                                        class: "input-sm text-center",
                                                        "onUpdate:modelValue": ($event) => ((det.cantidadEtiquetas) = $event)
                                                    }, null, 8 /* PROPS */, _hoisted_51), [
                                                        [
                                                            _vModelText,
                                                            det.cantidadEtiquetas,
                                                            void 0,
                                                            { number: true }
                                                        ]
                                                    ])
                                                ]),
                                                _createElementVNode("td", _hoisted_52, [
                                                    _createElementVNode("button", {
                                                        class: "btn-icon-sm",
                                                        onClick: ($event) => (verEtiqueta(det)),
                                                        title: "Ver Etiqueta"
                                                    }, _hoisted_55, 8 /* PROPS */, _hoisted_53)
                                                ])
                                            ]));
                                        }), 128 /* KEYED_FRAGMENT */))
                                    ])
                                ])
                            ])
                        ]),
                        _createCommentVNode(" Footer de Acciones "),
                        _createElementVNode("div", _hoisted_56, [
                            _hoisted_57,
                            _createElementVNode("div", _hoisted_58, [
                                _createElementVNode("button", {
                                    class: "btn-outline-action",
                                    onClick: _cache[2] || (_cache[2] = ($event) => (imprimirEtiquetas(false)))
                                }, [
                                    _hoisted_59,
                                    _createTextVNode(" Selección Parcial ")
                                ]),
                                _createElementVNode("button", {
                                    class: "btn-dark-action",
                                    onClick: _cache[3] || (_cache[3] = ($event) => (imprimirEtiquetas(true)))
                                }, [
                                    _hoisted_60,
                                    _createTextVNode(" Imprimir Totalidad (" + _toDisplayString(totalEtiquetas.value) + " etiquetas) ", 1 /* TEXT */)
                                ])
                            ])
                        ])
                    ]))
                    : _createCommentVNode("v-if", true)
            ]));
        };
    }
});
